// extracted by mini-css-extract-plugin
export var alt = "PhotosGallery-module--alt--0f7d7";
export var container = "PhotosGallery-module--container--24b8d";
export var content = "PhotosGallery-module--content--7c722";
export var desktopOnly = "PhotosGallery-module--desktopOnly--e2447";
export var main = "PhotosGallery-module--main--2a7a2";
export var mobileOnly = "PhotosGallery-module--mobileOnly--9d2e9";
export var photoContainer = "PhotosGallery-module--photoContainer--d5805";
export var photosMore = "PhotosGallery-module--photosMore--4318e";
export var row1 = "PhotosGallery-module--row1--1758e";
export var row2 = "PhotosGallery-module--row2--dda43";
export var textLeft = "PhotosGallery-module--textLeft--81db3";
export var thumbnail = "PhotosGallery-module--thumbnail--007fd";
export var visuallyHidden = "PhotosGallery-module--visuallyHidden--c604a";